import { scrollPlaylistToLesson } from "./playlist_scroll";
import { updateCollapsedMobileWindow } from "./mobile_playlist_visibility";

const SELECTOR_SLIDER_CONTAINER = ".js-lesson-slider-container";
const SELECTOR_PLAYLIST_CONTAINER = ".js-playlist-container";
const SELECTOR_PLAYLIST_ITEM = ".js-playlist-item";

function updateLessonListState(player) {
  const lessonId = player.el().dataset.lessonId;
  if (!lessonId) return;

  const slider = document.querySelector<HTMLElement>(SELECTOR_SLIDER_CONTAINER);
  const container = document.querySelector<HTMLElement>(
    SELECTOR_PLAYLIST_CONTAINER
  );

  if (!slider || !container) return;

  const items = Array.from(
    slider.querySelectorAll<HTMLElement>(SELECTOR_PLAYLIST_ITEM)
  );

  if (!items.length) return;

  const activeItem = slider.querySelector<HTMLElement>(
    `[data-lesson-id='${lessonId}']`
  );

  if (!activeItem) return;

  // Reset all items to the non-highlighted state
  items.forEach((item) => {
    item.classList.remove("bg-neutral-850");
    item.classList.add("bg-neutral-900");
  });

  // Highlight the active lesson item
  activeItem.classList.remove("bg-neutral-900");
  activeItem.classList.add("bg-neutral-850");

  updateCollapsedMobileWindow(slider, activeItem, items);

  scrollPlaylistToLesson(container, lessonId, {
    behavior: "smooth",
    offsetItems: 1,
  });
}

export { updateLessonListState };
